import { useState, useEffect } from "react";
import { useLanguageContext } from "../../Context/LanguageContext";
import graphDashboardStore from "../../Stores/GraphDashboardStore";
import GraphDashboardContants from "../../Constants/GraphDashboardConstants";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import { useSelectedConfigActionContext } from "../../Context/GlobalContext";

import {
  useTourGuidSavedSettingActionsContext,
  useTourGuidStartActionsContext,
  useTourGuidSavedSettingContext,
} from "../../Context/TourGuidContext";
import { TourGuideHelper } from "../../helpers/TourGuide/TourGuideHelper";
import DynamicChartContainer from "./MuiCharts/DynamicChartContainer";
import { Box, Grid, Tab } from "@mui/material";
import {
  KpiStatusChart,
  apiPayloadCreation,
} from "./MuiCharts/DashBoardHelperFunction";
import { useSelectedPlantContext } from "../../Context/GlobalContext";
import equipmentGroupStore from "../../Stores/EquipmentGroupStore";
import EquipmentGroupContants from "../../Constants/EquipmentGroupConstants";
import GraphDashboardActions from "../../Actions/GraphDashboardActions";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import commonUtils from "../../helpers/commonUtils";
import AppConstants from "../../Constants/AppConstants";
import { toast } from "react-toastify";

const dashBoardSectionName = [
  "InspectionKpi",
  "EquiStatusDistribution",
  "TicketKpi",
  "OrganisationKpi",
];
function GraphDashboard() {
  const UpdateTourStatus = useTourGuidStartActionsContext();
  const tourGuidSaveSetting = useTourGuidSavedSettingContext();
  const setTourGuidSaveSetting = useTourGuidSavedSettingActionsContext();
  const selectedPlant = useSelectedPlantContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [chartData, setChartData] = useState(null);
  const [showChart, setShowChart] = useState(false);
  const [equipmentGroupList, setEquipmentGroupList] = useState([]);
  const [selectedEquipmentGroupId, setSelectedEquipmentGroupId] = useState("");
  const [tabValue, setTabValue] = useState("1");
  const { language, localization } = useLanguageContext();
  const updateSelectedConfig = useSelectedConfigActionContext();
  const [dashboardSummary, setDashboardSummary] = useState({});

  // Map keys to readable labels
  const dashboardLabels = {
    totalUsers: localization.totalUsers,
    totalInspections: localization.totalInspections,
    nextInspectionDateNotDefinedCount:
      localization.nextInspectionDateNotDefined,
    overdueInspectionCount: localization.overdueInspections,
    totalPendingInspections: localization.pendingInspections,
    nioInspectionCount: localization.nioInspections,
    totalEquipmentGroupCount: localization.equipmentGroups,
    totalEquipmentCount: localization.totalEquipment,
  };

  useEffect(() => {
    if (selectedPlant) {
      setShowChart(false);
    }
  }, [selectedPlant]);

  useEffect(() => {
    sessionStorage.setItem("dashboardTabValue", "1");
    return () => {};
  }, []);

  /**--------------------------InspectionKpiData Start----------------- */
  useEffect(() => {
    if (chartData) {
      let containsAllKeys = false;
      if (commonUtils.isUserOrganisationAdmin()) {
        containsAllKeys = dashBoardSectionName.every((key) =>
          Object.prototype.hasOwnProperty.call(chartData, key),
        );
      } else {
        containsAllKeys = dashBoardSectionName
          .filter(filterPlantLevelKPI)
          .every((key) => Object.prototype.hasOwnProperty.call(chartData, key));
      }

      if (containsAllKeys) {
        setShowChart(true);
        const tourStatus = TourGuideHelper.returnCurrentTourState(
          tourGuidSaveSetting,
          setTourGuidSaveSetting,
          "welcometour",
        );

        if (tourStatus.length > 0) {
          UpdateTourStatus({
            tourTitle: tourStatus[0].title,
            tourStatus: true,
            anyStep: 0,
          });
        }
        setGlobalSpinner(false);
      }
    }
  }, [chartData]);

  useEffect(() => {
    function getInspectionKpiSuccess() {
      var res = graphDashboardStore.getInspectionKpiResult();

      let structuredChartData = {};
      res.forEach((element) => {
        const _tempItem = KpiStatusChart(
          element,
          localization,
          "inspectionKpi",
        );
        structuredChartData[element["chartId"]] = {
          ...structuredChartData,
          ..._tempItem[element["chartId"]],
        };
      });

      if (res) {
        setChartData((prev) => ({
          ...prev,
          InspectionKpiHed: localization.inspectionKpiHead,
          InspectionKpi: [
            {
              sections: [
                structuredChartData["EquipmentGroupTotalInspectionData"],
                structuredChartData["InspectionCompletionRate"],
              ],
            },
            {
              sections: [structuredChartData["InspectorPerfomanceData"]],
            },
          ],
        }));
      }
    }

    function getInspectionKpiFailure() {
      var res = graphDashboardStore.getInspectionKpiResult();
      toast.error(res);
    }

    graphDashboardStore.addChangeListener(
      GraphDashboardContants.GET_INSPECTION_KPI_DATA_SUCCESS,
      getInspectionKpiSuccess,
    );

    graphDashboardStore.addChangeListener(
      GraphDashboardContants.GET_INSPECTION_KPI_DATA_FAILURE,
      getInspectionKpiFailure,
    );

    return () => {
      graphDashboardStore.removeChangeListener(
        GraphDashboardContants.GET_INSPECTION_KPI_DATA_SUCCESS,
        getInspectionKpiSuccess,
      );

      graphDashboardStore.removeChangeListener(
        GraphDashboardContants.GET_INSPECTION_KPI_DATA_FAILURE,
        getInspectionKpiFailure,
      );
    };
  }, []);

  /**--------------------------InspectionKpiData End----------------- */

  /**--------------------------EquipmentStautsdistribution Start----------------- */

  useEffect(() => {
    function getDashboardGraphSuccess() {
      var res = graphDashboardStore.getequipmentStatusDistributionResult();
      let structuredChartData = {};
      res.forEach((element) => {
        const _tempItem = KpiStatusChart(
          element,
          localization,
          "equipmentStatus",
        );
        structuredChartData[element["chartId"]] = {
          ...structuredChartData,
          ..._tempItem[element["chartId"]],
        };
      });

      if (res) {
        setChartData((prev) => ({
          ...prev,
          EquiStatusDistributionHed: localization.equipmentKpiHead,
          EquiStatusDistribution: [
            {
              sections: [
                structuredChartData["EquipmentStatusDistribution"],
                structuredChartData["EquipmentFrequencyFailures"],
              ],
            },
            {
              sections: [
                structuredChartData["PlantEquipmentData"],
                structuredChartData["EquipmentScrappedData"],
              ],
            },
          ],
        }));
      }

      updateSelectedConfig("");
    }

    function getDashboardGraphFailure() {
      updateSelectedConfig("");
    }

    graphDashboardStore.addChangeListener(
      GraphDashboardContants.GET_DASHBOARD_GRAPH_EQUIPMENTSTATUS_SUCCESS,
      getDashboardGraphSuccess,
    );

    graphDashboardStore.addChangeListener(
      GraphDashboardContants.GET_DASHBOARD_GRAPH_EQUIPMENTSTATUS_FAILURE,
      getDashboardGraphFailure,
    );

    return () => {
      graphDashboardStore.removeChangeListener(
        GraphDashboardContants.GET_DASHBOARD_GRAPH_EQUIPMENTSTATUS_SUCCESS,
        getDashboardGraphSuccess,
      );

      graphDashboardStore.removeChangeListener(
        GraphDashboardContants.GET_DASHBOARD_GRAPH_EQUIPMENTSTATUS_FAILURE,
        getDashboardGraphFailure,
      );
    };
  }, []);

  /**--------------------------EquipmentStautsdistribution End----------------- */

  /**--------------------------Ticket Kpi Start */
  useEffect(() => {
    function getTicketKpiSuccess() {
      var res = graphDashboardStore.getTicketKpiResult();

      let structuredChartData = {};
      res.forEach((element) => {
        const _tempItem = KpiStatusChart(element, localization, "TicketKpi");
        structuredChartData[element["chartId"]] = {
          ...structuredChartData,
          ..._tempItem[element["chartId"]],
        };
      });

      if (res) {
        setChartData((prev) => ({
          ...prev,
          TicketKpiHed: localization.ticketKpiHead,
          TicketKpi: [
            {
              sections:
                prev &&
                prev.TicketKpi &&
                prev.TicketKpi[0] &&
                prev.TicketKpi[0].sections &&
                prev.TicketKpi[0].sections[1]
                  ? [
                      structuredChartData["NumberOfTicketsPerEquipmentGroup"],
                      prev.TicketKpi[0].sections[1],
                    ]
                  : [structuredChartData["NumberOfTicketsPerEquipmentGroup"]],
            },
          ],
        }));
      }
    }

    function getTicketKpiFailure() {}

    graphDashboardStore.addChangeListener(
      GraphDashboardContants.GET_TICKET_KPI_DATA_SUCCESS,
      getTicketKpiSuccess,
    );

    graphDashboardStore.addChangeListener(
      GraphDashboardContants.GET_TICKET_KPI_DATA_FAILURE,
      getTicketKpiFailure,
    );

    return () => {
      graphDashboardStore.removeChangeListener(
        GraphDashboardContants.GET_TICKET_KPI_DATA_SUCCESS,
        getTicketKpiSuccess,
      );

      graphDashboardStore.removeChangeListener(
        GraphDashboardContants.GET_TICKET_KPI_DATA_FAILURE,
        getTicketKpiFailure,
      );
    };
  }, []);

  useEffect(() => {
    function getEquipmentTicketKpiSuccess() {
      var res = graphDashboardStore.getEquipmentTicketKpiResult();

      let structuredChartData = {};
      res.forEach((element) => {
        const _tempItem = KpiStatusChart(element, localization, "TicketKpi");
        structuredChartData[element["chartId"]] = {
          ...structuredChartData,
          ..._tempItem[element["chartId"]],
        };
      });

      if (res) {
        setChartData((prev) => ({
          ...prev,

          TicketKpi: [
            {
              sections:
                prev &&
                prev.TicketKpi &&
                prev.TicketKpi[0] &&
                prev.TicketKpi[0].sections &&
                prev.TicketKpi[0].sections[0]
                  ? [
                      prev.TicketKpi[0].sections[0],
                      structuredChartData["NumberOfTicketsPerEquipment"],
                      ,
                    ]
                  : [structuredChartData["NumberOfTicketsPerEquipment"]],
            },
          ],
        }));
      }
      if (!commonUtils.isUserOrganisationAdmin()) {
        setGlobalSpinner(false);
      }
    }

    function getEquipmentTicketKpiFailure() {
      if (!commonUtils.isUserOrganisationAdmin()) {
        setGlobalSpinner(false);
      }
    }

    graphDashboardStore.addChangeListener(
      GraphDashboardContants.GET_EQUIPMENT_TICKET_KPI_DATA_SUCCESS,
      getEquipmentTicketKpiSuccess,
    );

    graphDashboardStore.addChangeListener(
      GraphDashboardContants.GET_EQUIPMENT_TICKET_KPI_DATA_FAILURE,
      getEquipmentTicketKpiFailure,
    );

    return () => {
      graphDashboardStore.removeChangeListener(
        GraphDashboardContants.GET_EQUIPMENT_TICKET_KPI_DATA_SUCCESS,
        getEquipmentTicketKpiSuccess,
      );

      graphDashboardStore.removeChangeListener(
        GraphDashboardContants.GET_EQUIPMENT_TICKET_KPI_DATA_FAILURE,
        getEquipmentTicketKpiFailure,
      );
    };
  }, []);

  /*-------------------------Organisation Kpi Start-----------------*/
  useEffect(() => {
    function getOrgKpiSuccess() {
      var res = graphDashboardStore.getOrgKpiResult();

      let structuredChartData = {};
      res.forEach((element) => {
        const _tempItem = KpiStatusChart(
          element,
          localization,
          "OrganisationKpi",
        );
        structuredChartData[element["chartId"]] = {
          ...structuredChartData,
          ..._tempItem[element["chartId"]],
        };
      });

      if (res) {
        setChartData((prev) => ({
          ...prev,
          OrganisationKpiHed: localization.organisationKpiHead,
          OrganisationKpi: [
            {
              sections: [
                structuredChartData["OrganizationInspectorPerfomanceData"],
              ],
            },
            {
              sections: [structuredChartData["OrganizationEquipmentData"]],
            },
            {
              sections: [
                structuredChartData["OrganizationInspectionCompletionRate"],
              ],
            },
          ],
        }));
      }
    }

    function getOrgKpiFailure() {}

    graphDashboardStore.addChangeListener(
      GraphDashboardContants.GET_ORG_KPI_DATA_SUCCESS,
      getOrgKpiSuccess,
    );

    graphDashboardStore.addChangeListener(
      GraphDashboardContants.GET_ORG_KPI_DATA_FAILURE,
      getOrgKpiFailure,
    );

    return () => {
      graphDashboardStore.removeChangeListener(
        GraphDashboardContants.GET_ORG_KPI_DATA_SUCCESS,
        getOrgKpiSuccess,
      );

      graphDashboardStore.removeChangeListener(
        GraphDashboardContants.GET_ORG_KPI_DATA_FAILURE,
        getOrgKpiFailure,
      );
    };
  }, []);

  /*-------------------------Organisation Kpi End-----------------*/

  /*-----------------------Dashboard Summary Start---------------------------------------*/

  useEffect(() => {
    function getDashboardSummaryDataSuccess() {
      var res = graphDashboardStore.getDashboardSummaryResult();
      setDashboardSummary(res);
      setGlobalSpinner(false);
    }

    function getDashboardSummaryDataFailure() {
      setGlobalSpinner(false);
    }

    graphDashboardStore.addChangeListener(
      GraphDashboardContants.GET_DASHBOARD_SUMMARY_DATA_SUCCESS,
      getDashboardSummaryDataSuccess,
    );

    graphDashboardStore.addChangeListener(
      GraphDashboardContants.GET_DASHBOARD_SUMMARY_DATA_FAILURE,
      getDashboardSummaryDataFailure,
    );

    return () => {
      graphDashboardStore.removeChangeListener(
        GraphDashboardContants.GET_DASHBOARD_SUMMARY_DATA_SUCCESS,
        getDashboardSummaryDataSuccess,
      );

      graphDashboardStore.removeChangeListener(
        GraphDashboardContants.GET_DASHBOARD_SUMMARY_DATA_FAILURE,
        getDashboardSummaryDataFailure,
      );
    };
  }, []);

  /*--------------------------Dashboard Summary End---------------------------------------*/

  useEffect(() => {
    function getPlantEqipmentGroupSuccess() {
      var res = equipmentGroupStore.getPlantEquipmentGroupList();
      if (res.length > 0) {
        setEquipmentGroupList(res);
        setSelectedEquipmentGroupId(res[0].id);
      } else {
        setEquipmentGroupList([]);
      }
    }

    function getPlantEqipmentGroupFailure() {
      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_PLANT_EQUIPMENT_GROUP_SUCCESS,
      getPlantEqipmentGroupSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_PLANT_EQUIPMENT_GROUP_FAILURE,
      getPlantEqipmentGroupFailure,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_PLANT_EQUIPMENT_GROUP_SUCCESS,
        getPlantEqipmentGroupSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_PLANT_EQUIPMENT_GROUP_FAILURE,
        getPlantEqipmentGroupFailure,
      );
    };
  }, []);

  useEffect(() => {
    if (selectedEquipmentGroupId != "") {
      let payLoad = apiPayloadCreation(30, sessionStorage.getItem("werkId"));
      payLoad["AnlagegruppeId"] = selectedEquipmentGroupId;
      setGlobalSpinner(true);
      GraphDashboardActions.getEqupipmentTicketCountKPIData(payLoad);
    }

    return () => {};
  }, [selectedEquipmentGroupId]);

  const handleChange = (e, newValue) => {
    setTabValue(newValue);
  };

  const filterPlantLevelKPI = (item) => {
    return item !== "OrganisationKpi";
  };

  const filterOrgLevelKPI = (item) => {
    return item == "OrganisationKpi";
  };

  useEffect(() => {
    sessionStorage.setItem("dashboardTabValue", tabValue);
    getOrganisationSummaryDetails();
    return () => {};
  }, [tabValue]);

  const getOrganisationSummaryDetails = () => {
    let payLoad = "";
    if (tabValue === "1") {
      payLoad = apiPayloadCreation(30, sessionStorage.getItem("werkId"));
    } else {
      payLoad = apiPayloadCreation(30, AppConstants.DEFAULT_GUID);
    }

    setGlobalSpinner(true);
    GraphDashboardActions.getDashboardSummaryData(payLoad);
  };

  function formatNumber(value) {
    if (value === null || value === undefined || isNaN(value)) return value;

    const localeMap = {
      en: "en-US", // 123,456
      de: "de-DE", // 123.456
      fr: "fr-FR", // 123 456
      hu: "hu-HU", // 123 456
      br: "pt-BR", // 123.456,78
    };

    const locale = localeMap[language] || "en-US";

    return Number(value).toLocaleString(locale);
  }

  /**--------------------------Ticket Kpi End */
  // Modern summary card styled like the screenshot
  function SummaryCardModern({ label, value }) {
    return (
      <div className="summaryCardContainer">
        <div className="summaryCardValue">{formatNumber(value)}</div>
        <div className="summaryCardLabel">{label}</div>
      </div>
    );
  }

  return (
    <>
      {/* Dashboard Summary Section */}

      <div className="w-100 dashboardTabContainer">
        <TabContext value={tabValue}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList onChange={handleChange} aria-label="KPITabs">
              <Tab
                sx={{ textTransform: "none" }}
                label={localization.PlantLevelKPI}
                value="1"
              />
              {commonUtils.isUserOrganisationAdmin() && (
                <Tab
                  sx={{ textTransform: "none" }}
                  label={localization.OrganisationLevelKPI}
                  value="2"
                />
              )}
            </TabList>
          </Box>
          <TabPanel value="1" className="graphDashBoardContainer">
            <div className="graphDashBoardContent">
              {Object.keys(dashboardSummary).map((key, idx) => (
                <SummaryCardModern
                  key={key}
                  label={dashboardLabels[key] || key}
                  value={dashboardSummary[key]}
                />
              ))}
            </div>

            {/* Graph Dashboard Container */}
            {showChart && (
              <Grid container spacing={3} sx={{ padding: 2 }} id="equipment">
                {dashBoardSectionName
                  .filter(filterPlantLevelKPI)
                  .map((item, index) => {
                    return (
                      <Grid item xs={12} key={index}>
                        <DynamicChartContainer
                          heading={chartData[item + "Hed"]}
                          rows={chartData[item]}
                          keyOfChart={item}
                          equipmentGroupList={equipmentGroupList}
                          selectedEquipmentGroupId={selectedEquipmentGroupId}
                          setSelectedEquipmentGroupId={
                            setSelectedEquipmentGroupId
                          }
                        />
                      </Grid>
                    );
                  })}
              </Grid>
            )}
          </TabPanel>
          <TabPanel value="2" className="graphDashBoardContainer">
            <div className="graphDashBoardContent">
              {Object.keys(dashboardSummary).map((key, idx) => (
                <SummaryCardModern
                  key={key}
                  label={dashboardLabels[key] || key}
                  value={dashboardSummary[key]}
                />
              ))}
            </div>

            {/* Graph Dashboard Container */}
            {showChart && (
              <Grid container spacing={3} sx={{ padding: 2 }} id="equipment">
                {dashBoardSectionName
                  .filter(filterOrgLevelKPI)
                  .map((item, index) => {
                    return (
                      <Grid item xs={12} key={index}>
                        <DynamicChartContainer
                          heading={chartData[item + "Hed"]}
                          rows={chartData[item]}
                          keyOfChart={item}
                          equipmentGroupList={equipmentGroupList}
                          selectedEquipmentGroupId={selectedEquipmentGroupId}
                          setSelectedEquipmentGroupId={
                            setSelectedEquipmentGroupId
                          }
                        />
                      </Grid>
                    );
                  })}
              </Grid>
            )}
          </TabPanel>
        </TabContext>
      </div>
    </>
  );
}

export default GraphDashboard;
